import {Input, Output, Component, OnInit, OnDestroy, ViewChild, EventEmitter, ElementRef} from '@angular/core';
import {reqBsk} from './../_const/const';
import {Table} from 'primeng/table';
import {MessagesService} from '@core/_services/messages.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'displayresultgrid',
    templateUrl: 'displayresultgrid.component.html',
    styleUrls: ['displayresultgrid.component.scss'],
    styles: [
        `
            :host ::ng-deep .p-table .p-table-thead > tr > th {
                position: -webkit-sticky;
                position: sticky;
                top: -1px;
            }
            :host ::ng-deep .p-datatable.p-datatable-striped .p-datatable-tbody > tr:nth-child(even) {
                background: rgba(0, 0, 0, 0.2);
            }

            :host ::ng-deep .p-datatable-wrapper {
                height:75vh;
            }

            :host ::ng-deep .scroll-table {
                height:85vh;
            }

            @media screen and (max-width: 64em) {
                :host ::ng-deep .p-table .p-table-thead > tr > th {
                    top: -1px;
                }
            }
        `,
    ],
})
export class DisplayResultGridComponent implements OnInit, OnDestroy {
    @Input() public originClick;
    @Input() public modeView;
    @Input() public modeDetail;
    @Input() public srchMode;
    @Input() public listColumns;
    @Input() public resultDisplay;
    @Input() public currentUser;
    @Input() public splitId;
    @Input() public hasLock = false;
    @Input() public pathPdf;
    @Input() public paramDetail;
    @Input() public fetchParam: any;

    @Output() public onClickItem = new EventEmitter<any>();
    @Output() public onClickcolpdf = new EventEmitter<any>();
    @Output() public onPageChange = new EventEmitter<any>();
    @Output() public onShowModal = new EventEmitter<any>();

    @ViewChild('dt') public dataTableUse: Table;
    @ViewChild('scrolltable') scrolltable: ElementRef;
    // @ViewChild('ckbox') public ckBox: TableCheckbox;

    public selectedDocs: any[];
    public curIndex: number;
    public curPage;
    public nbRow = 100;
    public currentDocId: any[];
    public reqBsk = reqBsk;
    public showThumb: boolean = false;
    public thumbs = '';
    private timer: any = null;
    private imgDocId = '';
    public first: number = 1;

    // private currentClick = undefined;

    constructor(protected _messageservice: MessagesService,
                private translate: TranslateService) {
        this.selectedDocs = new Array();
        this.curPage = 1;
        this.first = 1;
        // this.currentClick = undefined;        
    }

    public ngOnInit() {
        this.curPage = this.fetchParam.page;
        // this.currentClick = undefined;
    }

    public ngOnDestroy() {
        this.clearTime();
    }

    public ngOnChanges() {
    }

    public ngAfterViewInit() {
        let wCurIndex = this.dataTableUse.rows * (this.fetchParam.page) - this.dataTableUse.rows;
        this.dataTableUse.first = wCurIndex;
        this.setCurrentIndex(wCurIndex);
        this.onPageChange.emit(this.resultDisplay[this.curIndex].doc_docid);
    }

    public onRowSelect(event) {
        if (event.type === 'row') {
            this.onClickItem.emit(event.data.doc_docid);
        }
    }

    public clickcolpdf(event, adocid) {
        event.stopPropagation();
        if (this.modeView === 'S') {
            this.onClickcolpdf.emit({
                docId: adocid,
                modeView: this.modeView
            });
        } else {
            this.currentDocId = adocid;
            this.setSelectedDocIndex();
            this.onClickcolpdf.emit({
                docId: adocid,
                modeView: this.modeView
            });
        }
    }

    public clickcolck(event) {
        event.stopPropagation();
        // if (event.shiftKey === true) {
        //     const start = Math.min(this.currentClick, index);
        //     const end = Math.max(this.currentClick, index);
        //     console.log(this.currentClick, start, end);
        //     this.addSelected(start, end);   
        //     console.log(this.selectedDocs);
        //     // this.ckBox.onClick(null);
        //     // this.ckBox.checked = true;
        //     this.currentClick = index;         
        // } else {
        //     this.currentClick = index;              
        // }

        // if (this.currentClick === -1) {
        //     this.currentClick = index;
        // } else {
        //     if (event.shiftKey === true && index > this.currentClick + 1) {
        //         this.addSelected(this.currentClick, index);
        //         this.ckBox.onClick(null);
        //         this.ckBox.checked = true;
        //         this.currentClick = -1;
        //     }
        // }
        // if (event.shiftKey === false) {
        //     this.currentClick = -1;            
        // }
    }

    // private addSelected(aStart, aEnd) {
    //     let map = new Map();
    //     for (let obj of this.selectedDocs) {
    //       map.set(obj.doc_docid, obj); 
    //     }        
    //     for (let i = aStart; i < aEnd; i++) {
    //         if(!map.has(this.resultDisplay[i].doc_docid)) {
    //             map.set(this.resultDisplay[i].doc_docid, this.resultDisplay[i]);
    //             this.selectedDocs.push(this.resultDisplay[i]);
    //           }
    //     }
    // }

    public pageChange($event) {
        let splitId = this.resultDisplay[$event.first].doc_docid;
        this.setShowThumb(false);
        this.curPage = $event.first / $event.rows + 1;
        this.onPageChange.emit(splitId);       
        this.scrolltable.nativeElement.scrollTop = 0;
    }

    public goNextPage() {
        let wCurIndex = this.dataTableUse.rows * (this.curPage + 1) - this.dataTableUse.rows;
        this.dataTableUse.first = wCurIndex;
        this.curPage++;
        this.setCurrentIndex(wCurIndex);
    }

    public posFirstIndex() {
        let wCurIndex = this.dataTableUse.rows * (this.curPage) - this.dataTableUse.rows;
        this.setCurrentIndex(wCurIndex);
    }

    public getCurrentIndex() {
        return this.curIndex;
    }

    public verifyGoNextPage() {
        if (this.curPage !== this.getMaxPage(this.dataTableUse)) {
            return true;
        } else {
            return false;
        }
    }

    public getNextIndex() {
        let wIndex = this.dataTableUse.rows * (this.curPage + 1) - this.dataTableUse.rows;
        return wIndex;
    }

    public setSelection() {
        this.selectedDocs = [];
        this.selectedDocs.push(this.dataTableUse._value[this.curIndex]);
        this.currentDocId = this.dataTableUse._value[this.curIndex].doc_docid;
    }

    public setSelectedDocIndex() {
        this.curIndex = this.getSelectedDocIndexFromId();
    }

    public setTotalDoc(aTotDoc) {
        this.dataTableUse.totalRecords = aTotDoc;
    }

    public setCurrentIndex(aIndex) {
        this.curIndex = aIndex;
    }

    public getSelectedDocIndexFromId() {
        let windex = -1;
        windex = this.dataTableUse._value.findIndex((item) => {
            return item.doc_docid === this.currentDocId;
        });
        return windex;
    }

    public setNextIndex() {
        this.curIndex++;
    }

    public setPrevIndex() {
        this.curIndex--;
    }

    public getNumPageFromIndex(aIndex) {
        let wNumPage = aIndex / this.dataTableUse.rows;
        wNumPage = Math.floor(wNumPage + 1);
        return wNumPage;
    }

    public setNumPageFromIndex(aIndex) {
        this.curPage = this.getNumPageFromIndex(aIndex);
    }

    public verifyGoPreviousPage() {
        if (this.getNumPageFromIndex(this.curIndex - 1) !== this.curPage) {
            return true;
        } else {
            return false;
        }
    }

    public verifyGoNextDoc() {
        if (this.dataTableUse.totalRecords === this.curIndex + 1) {
            return true;
        } else {
            return false;
        }
    }

    public verifyNextDoc() {
        if (this.getNumPageFromIndex(this.curIndex + 1) !== this.curPage) {
            return true;
        } else {
            return false;
        }
    }

    public goPreviousPage() {
        let wCurIndex = this.dataTableUse.rows * (this.curPage - 1) - this.dataTableUse.rows;
        this.dataTableUse.first = wCurIndex;
        this.curPage--;
        this.setCurrentIndex(wCurIndex + this.dataTableUse.rows - 1);
    }

    private getMaxPage(adatable) {
        let wMax = adatable.totalRecords / adatable.rows;
        if (adatable.totalRecords % adatable.rows === 0) {
            return wMax;
        } else {
            return Math.floor(wMax + 1);
        }
    }

    async copyvalue(event, data) {
        try {
            let selBox = document.createElement('textarea');
            selBox.style.position = 'fixed';
            selBox.style.left = '0';
            selBox.style.top = '0';
            selBox.style.opacity = '0';
            selBox.value = data;
            document.body.appendChild(selBox);
            selBox.focus();
            selBox.select();
            await this.copyToClipboard(data);
            document.body.removeChild(selBox);
            this._messageservice.addSuccess(this.translate.instant('Copy_OK'));
        } catch (e) {
            this._messageservice.addWarnNoStick(this.translate.instant('Copy_KO'));
        }
    }

    private async copyToClipboard(data: string): Promise<void> {
        try {
            await navigator.clipboard.writeText(data);
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    }

    public clickImg() {
        this.onClickItem.emit(this.imgDocId);
    }

    public showImage(url800: any, aDocId) {
        if (!this.timer) {
            this.timer = setTimeout(() => {
                    this.setShowThumb(true);
                    this.changeImage(url800, aDocId)
                    this.onShowModal.emit(true);
            }, 1000);
        }
    }

    public changeImage(url800: any, aDocId) {
        if (this.showThumb) {
            this.thumbs = url800;
            this.imgDocId = aDocId;
        }
    }

    public hideImage() {
        this.thumbs = null;
        this.setShowThumb(false);
        this.onShowModal.emit(false);
    }

    public clearTime() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }

    public setShowThumb(aShow) {
        this.showThumb = aShow;
    }
}
